export const dataHooks = {
  input: 'hiddenRadio',
  label: 'radio-label',
  icon: 'radio-icon',
};

export const SIZES = { SMALL: 'small', MEDIUM: 'medium' } as const;
export const ALIGN_ITEMS = { TOP: 'top', CENTER: 'center' } as const;
